import { useState } from 'react';
import { useQueryClient } from 'react-query';
import { useGetQuery } from '../useGetQuery';
import { TreasuryAccount } from '../../interfaces/Treasury';

interface UseTreasuryAccountsProps {
    params?: Record<string, any>;
    enabled?: boolean;
}

export const useTreasuryAccounts = ({
    params = {},
    enabled = true
}: UseTreasuryAccountsProps = {}) => {
    const queryClient = useQueryClient();
    const [connectUrl, setConnectUrl] = useState<string | null>(null);

    const { isLoading: isLoadingAccounts, isFetching, entries } = useGetQuery<{
        accounts: TreasuryAccount[];
    }>({
        url: '/banks/connect',
        cacheKey: `treasury-accounts-${params.page}`,
        params,
        enabled
    });

    const invalidateAccountsCache = () => {
        queryClient.invalidateQueries({
            queryKey: [`treasury-accounts-${params?.page}`, params]
        });
    };

    const closeModal = () => {
        invalidateAccountsCache();
        setConnectUrl(null);
    };

    return {
        connectUrl,
        closeModal,
        isLoadingAccounts,
        accounts: entries?.accounts ?? [],
        isFetching,
        refetchAccounts: invalidateAccountsCache
    };
};
